import { Avatar, createStyles, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';

import { ReactComponent as Edit } from '../../../assets/edit.svg';
import { colorPalette } from '../../../theme';
import { ButtonColor } from '../../shared/primitives/PlexButton';
import { IconButtonSize, PlexIconButton } from '../../shared/primitives/PlexIconButton';
import { PlexImageInput } from '../../shared/primitives/PlexImageInput';

type Props = {
  alt: string;
  picture: string | undefined;
  loading: boolean;
  onUploadComplete: (file: string) => void;
};

export const EditableAvatar = ({ alt, picture, loading, onUploadComplete }: Props): React.ReactElement => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  return (
    <div className={classes.avatarContainerInner}>
      <Avatar className={classes.avatar} alt={alt} src={picture} />
      <PlexIconButton
        className={classes.editAvatarButton}
        SvgIcon={Edit}
        color={ButtonColor.TransparentGray}
        tooltip={'Edit'}
        size={IconButtonSize.Normal}
        onClick={(): void => setOpen(true)}
      />
      <PlexImageInput loading={loading} open={open} setOpen={setOpen} onUploadComplete={onUploadComplete} />
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    avatarContainerInner: {
      position: 'relative',
      marginBottom: 24,
      marginTop: 24,
      marginLeft: 48,
      marginRight: 'auto',
      width: 150,
    },
    avatar: {
      width: 150,
      height: 150,
      borderRadius: 75,
    },
    editAvatarButton: {
      right: 0,
      bottom: 0,
      position: 'absolute',
      backgroundColor: '#fff',
      border: `1px solid ${colorPalette.purpleGray._100}`,
      borderRadius: 22,
    },
  })
);
